/* SJ search: podpowiedzi pod polem wyszukiwania w headerze (bez drawera) */
(function(){
  function init(){
    var form = document.querySelector('.searchinline form.search');
    if(!form || form.dataset.sjSuggest) return;
    var input = form.querySelector('input[name="q"]');
    if(!input) return;
    form.dataset.sjSuggest = '1';
    var box = document.createElement('div');
    box.className = 'sj-suggest';
    form.appendChild(box);
    var timer = null, ctrl = null, lastTerm = '';
    function hide(){ box.classList.remove('open'); }
    function show(){ if(box.innerHTML.trim()) box.classList.add('open'); }
    function fetchTerm(term){
      if(ctrl) ctrl.abort();
      ctrl = new AbortController();
      var base = (window.routes && routes.predictive_search_url) || '/search/suggest';
      fetch(base + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&section_id=predictive-search', {signal: ctrl.signal})
        .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(text){
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var sec = doc.querySelector('#shopify-section-predictive-search');
          box.innerHTML = sec ? sec.innerHTML : '';
          box.querySelectorAll('a[href*="search"]').forEach(function(a){
            try{ var u=new URL(a.getAttribute('href'), location.origin);
              if(/\/search$/.test(u.pathname) && !u.searchParams.get('type')){ u.searchParams.set('type','product'); a.setAttribute('href', u.pathname+u.search); }
            }catch(e){}
          });
          if(box.innerHTML.trim()) show(); else hide();
        })
        .catch(function(err){ if(err.name !== 'AbortError') hide(); });
    }
    input.addEventListener('input', function(){
      var term = input.value.trim();
      clearTimeout(timer);
      if(term.length < 2){ lastTerm=''; box.innerHTML=''; hide(); return; }
      timer = setTimeout(function(){
        if(term === lastTerm){ show(); return; }
        lastTerm = term;
        fetchTerm(term);
      }, 250);
    });
    input.addEventListener('focus', function(){ if(input.value.trim().length >= 2) show(); });
    input.addEventListener('keydown', function(e){ if(e.key === 'Escape') hide(); });
    document.addEventListener('click', function(e){ if(!form.contains(e.target)) hide(); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
